import React from 'react';
import './GraphicSection.css';


const graphicsList = [
    { id: 'graphic1', image: 'hypnose2.png', info: 'Hypnose ist eine tiefe Entspannung, die das Unterbewusstsein anspricht und positive Veränderungen ermöglicht.' },
    { id: 'graphic2', image: 'nlp2.png', info: 'NLP verbessert Kommunikation und verändert Verhaltensmuster durch die Verbindung von Neurologie, Sprache und erlernten Verhaltensweisen.' },
    { id: 'graphic3', image: 'coaching2.png', info: 'Coaching hilft dir, Ziele zu erreichen, Herausforderungen zu meistern und deine Potentiale zu entfalten.' },
    { id: 'graphic4', image: 'energieheilung2.png', info: 'Energieheilung stellt das energetische Gleichgewicht wieder her, aktiviert Selbstheilungskräfte und fördert das Wohlbefinden durch das Lösen von Blockaden.' },
  ];

const GraphicSection = ({ activeGraphic, onGraphicClick }) => (
  <section className="graphic-section">
    {graphicsList.map((graphic, index) => (
      <div
        key={index}
        className={`graphic ${activeGraphic === graphic.id ? 'active' : ''}`}
        onClick={() => onGraphicClick(graphic.id)}
      >
        <img
          src={require(`../assets/images/${graphic.image}`)}
          alt={graphic.title}
          className={`graphic-image ${activeGraphic === graphic.id ? 'blurred' : ''}`}
        />
        {activeGraphic === graphic.id && <div className="overlay-text">{graphic.info}</div>}
        <p className="graphic-text">{graphic.title}</p>
      </div>
    ))}
  </section>
);

export default GraphicSection;